/* global gettext */

export const initFilterCounters = () => {
    const catalogs = document.querySelectorAll('.common-catalog.list')
    catalogs.forEach(catalog => {
        const groupedFilters = catalog.querySelectorAll('.grouped-filters.bottom .filters')

        groupedFilters.forEach(filterGroup => {
            // Skip if counter already exists
            const existingCounter = filterGroup.querySelector('li.filter-counter')
            if (existingCounter) {
                return
            }

            const allItems = filterGroup.querySelectorAll('li')
            const hiddenCount = allItems.length - 1

            if (hiddenCount > 0) {
                const counter = document.createElement('li')
                counter.className = 'filter-counter'
                counter.textContent = `+${hiddenCount} ` + gettext('more')
                filterGroup.appendChild(counter)
            }
        })
    })
}
